import { ToastrService } from 'ngx-toastr';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import {
  IForfotPassword,
  IUserPkSk,
} from '../../../interfaces/type-auth.interface';
import { AuthService } from '../../../services/auth-service/auth.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '../../../services/translate/translate.service';
import { MangoEventAnalyticsService } from '../../../services/mango-events-analytics/mango-events-analytics.service';

interface TranslateData {
  title: string;
  messageReset: string;
  messageCheck: string;
  messageComplet: string;
  username: string;
  usernamePlaceholder: string;
  expire: string;
  newPassword: string;
  confirmPassword: string;
  passwordNotMatch: string;
  titleToast: string;
  contentToast: string;
  invalidCode: string;
  buttonCancek: string;
  buttonCheck: string;
  buttonresend: string;
  title2: string;
  buttonComplet: string;
  buttonSend: string;
}
@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnChanges, OnDestroy {
  @Input() statusModal: IForfotPassword = {
    statusModal: false,
    text: '',
    type: 'reset',
  } as IForfotPassword;
  @Output() closeModalForfot = new EventEmitter<IForfotPassword>();

  subscriptionTranslate!: Subscription;
  translate: TranslateData = {} as TranslateData;
  subscriptionSms$!: Subscription;
  username = '';
  typeResend = false;
  password = '';
  confirmPassword = '';
  code = '';
  minutes: string = '00';
  seconds: string = '00';
  timeCode$!: any;
  token = '';
  isInvalidCode = false;
  isInvalidPassword = false;
  isResend = true;
  isLoading = false;
  user: IUserPkSk = {} as IUserPkSk;
  constructor(
    private auth: AuthService,
    private translateService: TranslateService,
    private toastAlert: ToastrService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService
  ) {}

  ngOnInit(): void {
    this.username = '';
    this.dataTranslate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.username = '';
    this.password = '';
    this.confirmPassword = '';
    this.code = '';
    this.isInvalidCode = false;
    this.isInvalidPassword = false;
    this.typeResend = false;
    this.minutes = '00';
    this.seconds = '00';
    this.isLoading = false;
  }
  close() {
    const { statusModal, ...forgot } = this.statusModal;
    this.statusModal = {
      ...forgot,
      statusModal: false,
    };
    this.typeResend = false;
    this.closeModalForfot.emit(this.statusModal);
  }

  send() {
    this.isLoading = true;
    if (this.typeResend === false) {
      this.mangoEventAnalyticsService.sendEvent('forgot_password_request', {
        username: this.username,
        timestamp: new Date().toISOString(),
      });
      this.auth.forgotPassword(this.statusModal.url, this.username).subscribe(
        (resp: any) => {
          this.user = resp.user;
          const date = new Date(resp.timeExp);
          clearInterval(this.timeCode$);

          this.validationCodeTime(date);
          this.typeResend = true;
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_sent', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        },
        (error) => {
          this.toastAlert.error(
            'Error',
            error.error.errorMessage || 'Internal server error'
          );
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('forgot_password_error', {
            username: this.username,
            error: error.error?.errorMessage || 'Internal server error',
            timestamp: new Date().toISOString(),
          });
        }
      );
      //envio al correo
    } else {
      this.mangoEventAnalyticsService.sendEvent('forgot_password_code_verify', {
        username: this.username,
        timestamp: new Date().toISOString(),
      });
      this.authSms(this.code);
      // Validar codigo
    }
  }

  reSend() {
    this.isResend = true;
    this.typeResend = true;
    this.isLoading = true;
    this.mangoEventAnalyticsService.sendEvent('forgot_password_resend_code', {
      username: this.username,
      timestamp: new Date().toISOString(),
    });
    this.auth
      .forgotPassword(this.statusModal.url, this.username)
      .subscribe((resp: any) => {
        this.user = resp.user;
        this.isLoading = false;
        const date = new Date(resp.timeExp);
        clearInterval(this.timeCode$);
        this.validationCodeTime(date);
        this.mangoEventAnalyticsService.sendEvent('forgot_password_code_resent', {
          username: this.username,
          timestamp: new Date().toISOString(),
        });
      });
  }

  complet() {
    this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_attempt', {
      username: this.username,
      timestamp: new Date().toISOString(),
    });
    this.auth
      .resetPassword(
        this.statusModal.url,
        this.password,
        this.token.length > 0 ? this.username : ''
      )
      .subscribe(
        (resp: any) => {
          this.toastAlert.success(
            this.translate.titleToast,
            this.translate.contentToast
          );
          this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_success', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        },
        (err) => {
          this.toastAlert.error(
            'Error reset password',
            err.error.errorMessage ||
              'There was an error changing the password, please try again'
          );
          this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_error', {
            username: this.username,
            error: err.error?.errorMessage || 'Unknown error',
            timestamp: new Date().toISOString(),
          });
        }
      );

    this.close();
  }

  authSms(code: string) {
    this.subscriptionSms$ = this.auth
      .verifySms(
        this.statusModal.url,
        this.user?.pk || '',
        this.user?.sk || '',
        code
      )
      .subscribe(
        (resp: any) => {
          this.isInvalidCode = false;
          this.token = resp.jwtToken;
          const { type, ...forgot } = this.statusModal;
          this.statusModal = {
            ...forgot,
            type: 'create',
          };
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_verified', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        },
        (error) => {
          this.isInvalidCode = true;
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_invalid', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        }
      );
  }

  onCodeChanged(e: string) {
    this.code = e;
  }
  onCodeCompleted(e: string) {
    this.code = e;
  }

  dataPassword(event: string) {
    this.password = event;
    if (this.confirmPassword.length > 0) {
      this.isInvalidPassword =
        this.password === this.confirmPassword ? false : true;
    }
  }

  dataConfirmPassword(event: string) {
    this.confirmPassword = event;
    this.isInvalidPassword =
      this.password === this.confirmPassword ? false : true;
  }

  validationCodeTime(date = new Date()) {
    const currentDate: Date = new Date();
    const timeDate = date.getTime() - currentDate.getTime();
    date = new Date(timeDate);
    this.timeCode$ = setInterval(() => {
      if (timeDate > 0) {
        this.minutes = this.padLeft(date.getMinutes() + '');
        this.seconds = this.padLeft(date.getSeconds() + '');
        date = new Date(date.getTime() - 1000);
      }
      if (this.minutes == '00' && this.seconds == '00') {
        this.isResend = false;
        clearInterval(this.timeCode$);
      }
    }, 1000);
  }

  padLeft(time: string) {
    return '00'.substring(0, '00'.length - time.length) + time;
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.login.modalResetPassword;
      });
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
